export const email = {
  from: "From",
  to: "To",
  cc: "Cc",
  subject: "Subject",
  noSubject: "(No subject)",
  unknownSender: "Unknown sender",
  attachments: "%{count} attachment |||| %{count} attachments",
  messageCount: "%{count} message |||| %{count} messages",
  reply: "Reply",
  replyAll: "Reply all",
  forward: "Forward",
  replyingTo: "Replying to",
  composeMessage: "Compose your message...",
  sendHint: "Ctrl+Enter to send",
  enterUrl: "Enter the URL",
  invalidUrl: "Invalid URL. Only http/https URLs are allowed.",
  comingSoon: "Coming soon",
};
